import React from 'react'
import { Routes, Route, useSearchParams, useLocation} from "react-router-dom";
import { useSelector } from 'react-redux'

import {ApplyFilterParams} from '../utils/ApplyFilterParams'
import ReportsFilter from '../controls/ReportsFilter';
import DocumentsTable from '../controls/DocumentsTable'; 
import FilterCaption from '../controls/FilterCaption';

const FullDocuments = (props) => {

    const [searchParams] = useSearchParams();
    let filterData = useSelector(state => state.reportFilter);

    const location = useLocation();

    let url = "/job";
    if (location.search)
    {
        url += location.search + '&';
    }
    else
    {
        url += '?';
    }

    url += "sort=SubmitDate DESC&";
    url = ApplyFilterParams(url, filterData);
    
    return (
        <div className = "history-pane-header">
            <div className = "filter-report-picker"><ReportsFilter/></div>
            {location.search && <div className = "range-picker"><FilterCaption searchParams = {searchParams}/></div>}           
            <DocumentsTable api_url = {url} pageSize = {50} csvExport = {true}/>
        </div>
    );
}


const DocumentsPane = (props) => {  

    return (
        <div>
            <Routes>
                <Route path={"/"} element={<FullDocuments/>}/>
            </Routes>
        </div>
        );
}
  
export default DocumentsPane;